@if (isHeroPicture(item)) {
  <kb-hero-picture
    class="embedded"
    [picture]="item.picture"
    [alt]="item.alt"
    [heading]="item.heading"
    [headingLevel]="item.headingLevel ?? 2"
    [abstract]="item.abstract"
    [abstractMode]="abstractMode"
    [link]="item.link"
    [variants]="item.variants"
    [rootColumns]="rootColumns"
    [aboveFold]="aboveFold"
    [indented]="indented"
    [largeHeading]="largeHeading"
  />
} @else if (isHeroVideo(item)) {
  <kb-hero-video
    class="embedded"
    [src]="item.src"
    [poster]="item.poster"
    [crop]="item.crop ?? 'fit'"
    [autoplay]="item.autoplay ?? false"
    [loop]="item.loop ?? false"
    [heading]="item.heading"
    [headingLevel]="item.headingLevel ?? 2"
    [abstract]="item.abstract"
    [abstractMode]="abstractMode"
    [rootColumns]="rootColumns"
    [indented]="indented"
    [largeHeading]="largeHeading"
  />
}
